var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-card",style:(_vm.gridStyle),attrs:{"data-cy":"new-project-card"}},[_c('div',{staticClass:"plus-sign"}),_c('span',{staticClass:"title"},[_vm._v("New project")]),_c('div',{staticClass:"new-project-gif",on:{"click":_vm.newProject}})])
}
var staticRenderFns = []

export { render, staticRenderFns }